var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chartcontainer"}},[_c('span'),(_vm.loaded)?_c('line-graph',{attrs:{"height":300,"chartdata":_vm.chartComputedData,"options":_vm.options}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }